import React from "react";
import moment from "moment";
import SelectDateTime from "../../dashboards/Select.DateTime";
import { faSearch, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Col,
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
  Card,
  CardBody,
  CardHeader,
} from "reactstrap";

import { SelectMbId } from "./SelectMbId";
import PropTypes from "prop-types";
import { isZeroLengthString } from "../../../utils/normalize";

const MbIdLookUpFilter = (props) => {
  const { onUserAction, mbIdFilter, onSearchClick, loading, onClickUniqueIdFetch } = props;
  const { dt_create, mbId, mbIdSelectedOption, uniqueId, mbIdFetchList } = mbIdFilter;
  const isUniqueIdEntered = !isZeroLengthString(uniqueId);

  return (
    <Card>
      <CardHeader>
        <Row className="mb-1">
          <Col>
            <h4 className="text-muted">MbId Look Up</h4>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <Row>
          <Col>
            <p className="mb-0 pb-0">
              Note:-
              <li>
                Detailed Messages section [Messages, Email, SMS, Voice ] will list only past 3
                months info.{" "}
              </li>
              <ul>
                <li>
                  <b>If UniqueId available</b>
                </li>
                <ul>
                  <li>- First Scan to fetch associated MBIds in Select Drop Down. </li>
                  <li>
                    - Select MBId of interest from populated list, select start date and hit Lookup
                    Button to generate Details section.{" "}
                  </li>
                </ul>
                <li>
                  <b>If MBId available - </b>
                </li>
                <ul>
                  <li>Enter MbId, select date to start search from and hit LookUp</li>
                </ul>
              </ul>
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="ml-auto text-left mt-n1">
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>Unique Id</InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Unique Id"
                name="uniqueId"
                value={uniqueId}
                maxLength={70}
                size={50}
                onChange={(evt) => onUserAction("uniqueId", evt.currentTarget.value)}
              />
              <Button color="primary" onClick={(e) => onClickUniqueIdFetch()} disabled={loading}>
                Fetch MbId Options
                {loading && <FontAwesomeIcon icon={faSpinner} className="ml-2" spin />}
              </Button>
            </InputGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12} xs="auto" className="text-left mt-n1">
            <InputGroup className="mb-3">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <FontAwesomeIcon icon={faSearch} className="mr-2" />
                  {isUniqueIdEntered ? "Select MbId" : "Search Mb Id"}
                </InputGroupText>
              </InputGroupAddon>
              {!isUniqueIdEntered && (
                <Input
                  placeholder="MbId"
                  name="mbId"
                  value={mbId}
                  maxLength={50}
                  size={50}
                  onChange={(evt) => onUserAction("mbId", evt.currentTarget.value)}
                />
              )}
              {isUniqueIdEntered && (
                <SelectMbId
                  mbIdList={mbIdFetchList}
                  onUserAction={onUserAction}
                  defaultValue={mbIdSelectedOption}
                />
              )}
            </InputGroup>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="ml-auto text-right mt-n1">
            <SelectDateTime
              key="dt_create"
              name="Starting"
              field="dt_create"
              value={mbIdFilter.dt_create}
              onChange={(dateTime) => onUserAction("dt_create", dateTime)}
              isValidDate={(current) =>
                current.isBefore(moment()) && current.isAfter(moment().subtract(3, "months"))
              }
              inputProps={{ disabled: loading }}
            >
              {dt_create.isAfter(moment()) && (
                <small className="text-danger">Please select a date that is before now.</small>
              )}
              {dt_create.isBefore(moment().subtract(3, "months")) && (
                <small className="text-danger">
                  Date must be greater than {moment().subtract(3, "months").format("YYYY-MMM-DD")}
                </small>
              )}
            </SelectDateTime>
          </Col>
          <Col md={6} className="mt-n1">
            <Button color="primary" onClick={(e) => onSearchClick(e)} disabled={loading}>
              Lookup
              {loading && <FontAwesomeIcon icon={faSpinner} className="ml-2" spin />}
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

MbIdLookUpFilter.propTypes = {
  mbIdFilter: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  onSearchClick: PropTypes.func.isRequired,
  onUserAction: PropTypes.func.isRequired,
  onClickUniqueIdFetch: PropTypes.func.isRequired,
};
export default MbIdLookUpFilter;
